var _defs, _rect, _polygon, _polyline, _path, _path2, _path3, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232 232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6415ff;}.cls-2{fill:#f7fafc;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 232,
    height: 232,
    rx: 13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.44 104.08 167.49 44.8 64.04 96.1 132.44 104.08"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "134.25 107.75 65.85 99.75 133.03 126.4 169.31 48.46 134.25 107.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133,126.4,65.84,99.75,77.32,123l-9,4.42a2.65,2.65,0,0,0,2.33,4.71l9-4.42,18.9-9.37A2.65,2.65,0,0,1,100.9,123l-6.41,3.18L82,132.38l-10,5a2.65,2.65,0,1,0,1.75,5,2.19,2.19,0,0,0,.59-.3l10.06-5,4.09-2a2.65,2.65,0,0,1,2.34,4.71l-4.1,2-19.55,9.72A2.64,2.64,0,0,0,66,155.06h0a2.65,2.65,0,0,0,3.53,1.18L89,146.53l23.73-11.77a2.65,2.65,0,0,1,2.34,4.72l-11.44,5.67-12.26,6.08L52.78,170.36a2.65,2.65,0,0,0,1.64,5,2.33,2.33,0,0,0,.67-.33l38.59-19.13L106,149.86l3.61-1.76a2.65,2.65,0,1,1,3,4.4,3.07,3.07,0,0,1-.63.31l-2.83,1.41-12.81,6.35-.32.16a2.65,2.65,0,0,0,1.71,5,2.37,2.37,0,0,0,.62-.3l13.13-6.51a1.59,1.59,0,0,0,.57-.49L195.52,117a6.92,6.92,0,0,0,3.13-9.28h0L169.3,48.47Zm57.88-16.28a1.29,1.29,0,0,1-.52,1.74l-.06,0L151.63,131a1.28,1.28,0,0,1-1.74-.52l0-.06-.39-.78a1.28,1.28,0,0,1,.57-1.72h0l38.7-19.2a1.29,1.29,0,0,1,1.74.54l0,0Zm-3.08-6.18a1.29,1.29,0,0,1-.54,1.74l0,0-38.7,19.13a1.3,1.3,0,0,1-1.75-.56v0l-.39-.77a1.32,1.32,0,0,1,.55-1.76h0l38.7-19.18a1.28,1.28,0,0,1,1.74.52l0,.06Zm-3.08-6.18a1.29,1.29,0,0,1-.54,1.74l0,0-38.7,19.19a1.28,1.28,0,0,1-1.72-.58l-.39-.78a1.28,1.28,0,0,1,.58-1.72h0l38.69-19.18a1.28,1.28,0,0,1,1.73.52l0,.06ZM86.25,165.51l-1.61.8a2.65,2.65,0,0,0,1.7,5A2.84,2.84,0,0,0,87,171l1.61-.81a2.65,2.65,0,1,0-2.33-4.7Zm-38.81-10.1,6.18-3a2.65,2.65,0,0,0-2.34-4.72L45.1,150.7a2.65,2.65,0,0,0,2.34,4.71Zm-4.36,19.77-2.12,1a2.65,2.65,0,0,0,2.33,4.72l2.1-1a2.65,2.65,0,0,0-2.31-4.7Zm20.21-27.63,1.32-.64a2.65,2.65,0,0,0-1.77-5,2.51,2.51,0,0,0-.57.28l-1.31.65a2.65,2.65,0,1,0,1.71,5,2.77,2.77,0,0,0,.62-.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.49,188.48c2.47.1,143.07-70.54,143.07-70.54h0a23.28,23.28,0,0,1-15,21.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.67,114.15c1.42-2,142.38-72,142.38-72h0a23.27,23.27,0,0,0-26.4-1.09Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 147.44,
    cy: 174.89,
    r: 6.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 113.68,
    cy: 187.73,
    r: 6.76
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 181.2,
    cy: 162.06,
    r: 6.76
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0114f3847c7b0730a7b772e4377ccb11.svg";
export { ForwardRef as ReactComponent };